/**
 * @file モーダルに現在処理中のインデックスをセットする
 */
'use strict'

/**
 * @classname SetCurrentIndexToModal
 * @classdesc モーダルに現在処理中のインデックスをセットする
 */
export default class SetCurrentIndexToModal {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('#modal-common-member-search')
	 * @param {instance} controller
	 */
	constructor($e, controller) {
		console.log(`SetCurrentIndexToModal.constructor`)
		this._$e = $e
		this._controller = controller
		this._index = this._$e.data('index')
		this._$modal = $(this._$e.data('bs-target'))
		this._$e.on('click', () => this.onClick())
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof SetCurrentIndexToModal
	 * @return {undefined}
	 */
	onClick() {
		console.log(`SetCurrentIndexToModal.onClick / current index: ${this._index}`)
		this._$modal.attr('data-current-index', this._index)
	}
}
